import axios from 'axios';
import { NAMESPACES } from '../configuration';
const BASE_URL = NAMESPACES.users_api.auth;

// Base URL for the API
//const BASE_URL = 'https://server.mediopuntoapp.net/users_api/'; // Replace 'http://yourapiurl.com/api' with your actual API base URL

// Helper function to configure the Axios instance
const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

export async function loginUser(
  email: string, 
  password: string, 
  setLoading: (loading: boolean) => void, 
  setError: (error: any) => void
) {
  try {
    setLoading(true);

    const response = await api.post('/login', { email, password });
    if (response.status === 200) {
      // Save tokens to localStorage (user data will be handled by AuthProvider)
      localStorage.setItem('access_token', response.data.access_token);
      localStorage.setItem('refresh_token', response.data.refresh_token);
    }

    setError(null); // Clear any previous errors
    return { status: response.status, data: response.data }; // Always return an object
  } catch (error) {
    setLoading(false);

    if (axios.isAxiosError(error) && error.response) {
      // Return the API error details
      return { status: error.response.status, message: error.response.data.message };
    }

    // Handle unexpected errors
    setError('An unexpected error occurred');
    return { status: 500, message: 'An unexpected error occurred' };
  } finally {
    setLoading(false); // Ensure loading is false after execution
  }
}

// Function to logout the user from access token session
export async function logoutAccess(token: string) {
  try {
    const response = await api.post('/logout/access', {}, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data || 'An unexpected error occurred';
    }
    return 'An unexpected error occurred';
  }
}

// Function to logout the user from refresh token session
export async function logoutRefresh(refreshToken: string) {
  try {
    const response = await api.post('/logout/refresh', {}, {
      headers: {
        Authorization: `Bearer ${refreshToken}`
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data || 'An unexpected error occurred';
    }
    return 'An unexpected error occurred';
  }
}

/**
 * Refresh the access token using the stored refresh token.
 * Returns the new access token on success, or null if refresh failed.
 */
export async function refreshAccessToken(): Promise<string | null> {
  const refreshToken = localStorage.getItem('refresh_token');
  if (!refreshToken) {
    return null;
  }

  try {
    const response = await api.post('/refresh', {}, {
      headers: {
        Authorization: `Bearer ${refreshToken}`
      }
    });

    if (response.status === 200 && response.data.access_token) {
      localStorage.setItem('access_token', response.data.access_token);
      return response.data.access_token;
    }
    return null;
  } catch (error) {
    console.error('Token refresh failed:', error);
    return null;
  }
}
